// extracted by mini-css-extract-plugin
export var centerText = "_f3-8";
export var container = "_f3-0";
export var doughnutContainer = "_f3-7";
export var legend = "_f3-a";
export var legendItemColorDisplay = "_f3-b";
export var legendItemLabel = "_f3-d";
export var legendItemValue = "_f3-c";
export var lg = "_f3-5";
export var maxWidth = "_f3-9";
export var md = "_f3-4";
export var responsive = "_f3-6";
export var sm = "_f3-3";
export var xs = "_f3-2";
export var xxs = "_f3-1";